import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { TableSortLabel } from '@material-ui/core';

const styles = {
  paddingLeft32: {
    paddingLeft: '32px'
  }
};

const enhance = compose();

const tableHead = enhance(({ classes, order, orderBy, onRequestSort }) => {
  return (
    <TableHead>
      <TableRow>
        <TableCell sortDirection={orderBy === 'registeredAt' ? order : false}>
          <TableSortLabel
            active={orderBy === 'registeredAt'}
            direction={order}
            onClick={() => {
              onRequestSort('registeredAt');
            }}
          >
            申請日時
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'shopId' ? order : false}>
          <TableSortLabel
            active={orderBy === 'shopId'}
            direction={order}
            onClick={() => {
              onRequestSort('shopId');
            }}
          >
            店舗ID
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'groupName' ? order : false}>
          <TableSortLabel
            active={orderBy === 'groupName'}
            direction={order}
            onClick={() => {
              onRequestSort('groupName');
            }}
          >
            運営会社名
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'shopName' ? order : false}>
          <TableSortLabel
            active={orderBy === 'shopName'}
            direction={order}
            onClick={() => {
              onRequestSort('shopName');
            }}
          >
            店舗名
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'streetAddress' ? order : false}>
          <TableSortLabel
            active={orderBy === 'streetAddress'}
            direction={order}
            onClick={() => {
              onRequestSort('streetAddress');
            }}
          >
            住所
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'shopRegister' ? order : false}>
          <TableSortLabel
            active={orderBy === 'shopRegister'}
            direction={order}
            onClick={() => {
              onRequestSort('shopRegister');
            }}
          >
            店舗情報登録
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'menuRegister' ? order : false}>
          <TableSortLabel
            active={orderBy === 'menuRegister'}
            direction={order}
            onClick={() => {
              onRequestSort('menuRegister');
            }}
          >
            メニュー情報登録
          </TableSortLabel>
        </TableCell>
        <TableCell
          sortDirection={orderBy === 'identityRegister' ? order : false}
        >
          <TableSortLabel
            active={orderBy === 'identityRegister'}
            direction={order}
            onClick={() => {
              onRequestSort('identityRegister');
            }}
          >
            本人確認情報登録
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'stripeRegister' ? order : false}>
          <TableSortLabel
            active={orderBy === 'stripeRegister'}
            direction={order}
            onClick={() => {
              onRequestSort('stripeRegister');
            }}
          >
            Stripe情報登録
            <br />
            （自社で入金管理）
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'bankRegister' ? order : false}>
          <TableSortLabel
            active={orderBy === 'bankRegister'}
            direction={order}
            onClick={() => {
              onRequestSort('bankRegister');
            }}
          >
            銀行口座情報登録
          </TableSortLabel>
        </TableCell>
        <TableCell className={classes.paddingLeft32}>Remove Stripe</TableCell>
        <TableCell sortDirection={orderBy === 'status' ? order : false}>
          <TableSortLabel
            active={orderBy === 'status'}
            direction={order}
            onClick={() => {
              onRequestSort('status');
            }}
          >
            開店状況
          </TableSortLabel>
        </TableCell>
      </TableRow>
    </TableHead>
  );
});

export default withStyles(styles)(tableHead);
